



















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { DateTimeHelper } from '@/helper/date-time.helper';
import {
    GetVantivTransactionRequestModel, VantivTransactionModel,
    VantivTransactionDetailModel,
} from '@/models/payment/payment.transaction';
import { IDialogOption } from '@/models/dialog';
import { Base } from '@/components/common/base';
import downloadCsv from 'download-csv';
import { getVantiTransactionListHeaders } from '@/views/payment/payment';
import { storeService, paymentTransactionService } from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
        Calendar: () => import('@/components/common/app.calendar.vue'),
    },
})
export default class VantivTransactionsAppComponent extends Base {
    public headers: VHeaders[] = getVantiTransactionListHeaders(this);
    public pagedTransactions: VantivTransactionDetailModel[] = [];

    public showTransactionDetail: IDialogOption = {
        width: 600,
        title: ``,
        model: false,
    };

    public searchParameters: GetVantivTransactionRequestModel = {
        fromDate: '',
        toDate: '',
    };

    public transaction: VantivTransactionDetailModel = {};
    public downloadableFields = [];
    public loading: boolean = false;
    public actions: any[] = [];
    public pagination = new PaginationModel('ticketNumber', true);
    public vantivPaymentDepartmentTypes: any[] = [];

    public columns: {
        ticketNumber: 'Ticket Number',
        expressResponseMessage: 'Status',
        cardLogo: 'Card',
        timeStamp: 'Time Stamp',
        transactionAmount: 'Amount',
        transactionID: 'TransactionId',
        cardNumberMasked: 'Card Number',
    };

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'search') {
            this.getPaymentTransactions();
        }
        if (methodName === 'downloadCSVFile') {
            if (!(this.pagedTransactions.length > 0)) {
                this.showAlert(false, this.$t('vantivTransactions.alertNoPaymentTransationsdownload'));
                this.resetMethodName(methodName);
                return;
            }
            this.downloadCSVFile();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '1', type: 'button', title: this.$t('vantivTransactions.btnDownloadAll'), disabled: false, visible: true, class: 'btn', label: this.$t('vantivTransactions.btnDownloadAll'), click: 'downloadCSVFile', icon: 'fas fa-download' });
        this.$emit('updateToolBar', buttons);
    }

    public created(): void {
        this.searchParameters.fromDate = this.presentDate();
        this.searchParameters.toDate = this.presentDate();
    }

    public mounted(): void {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vantivTransactions');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        // SET startDate and endDate
        const date = new Date();
        date.setDate(date.getDate() - 6);

        this.getVantivPaymentDepartmentTypes();
        this.setActions();
    }

    public setActions() {
        this.actions = [
            {
                type: 'button',
                icon: 'fas fa-eye',
                title: this.$t('vantivTransactions.VantiveGridHeaders.gridAction.viewDetail') as string,
                visible: (model: VantivTransactionDetailModel) => {
                    return true;
                },
                action: (model: VantivTransactionDetailModel) => {
                    this.transaction = model;
                    this.setTransactionDetailTitle(model.ticketNumber);
                    this.showTransactionDetail.model = true;
                },
            },
        ];
    }

    public async getPaymentTransactions() {
        try {
            this.loading = true;
            this.$emit('update:progress', this.loading);
            const resp = await paymentTransactionService
                .getTransactions(this.searchParameters);

            this.pagedTransactions = resp.details || [];
            this.pagination.totalItems = this.pagedTransactions.length;
        } catch (e) {
            this.pagedTransactions = [];
            this.pagination.totalItems = 0;
        } finally {
            this.loading = false;
            this.$emit('update:progress', this.loading);
        }
    }
    public async getVantivPaymentDepartmentTypes() {
        const resp = await storeService
            .getVantivAccountTypes(0, true);
        this.vantivPaymentDepartmentTypes = resp.results;
    }
    public updatePaging(paging: any): void {
        this.pagination = paging;
    }
    public setTransactionDetailTitle(ticketNumber: string): void {
        this.showTransactionDetail.title = `Record Identifier #${ticketNumber} Transaction Information`;
    }
    public downloadCSVFile() {
        downloadCsv(this.pagedTransactions, this.columns, this.$t('vantivTransactions.vantivTransactionDownloadFileName'));
    }
    public setVantiveDateParameters(dates: any) {
        if (dates.length > 1) {
            this.searchParameters.fromDate = dates[0];
            this.searchParameters.toDate = dates[1];
        }
    }
}
